import { APP_BASE_HREF } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

/**
 * An interface that gives you the base app url (taking into account if baseHref is overidden)
 */
@Injectable()
export class BaseURLService {

  constructor(@Inject(APP_BASE_HREF) private baseHref:string) { }

  get(): string {
    return `${window.location.origin}${this.baseHref}`.replace(/\/$/, "");
  }

}
